import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import './index.css';
import { Typography, Flex, Button, Dropdown, Image } from 'antd';

const { Text } = Typography;

const Navbar = ({ isFooterLinkClicked }) => {
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [isNavShowing, setIsNavShowing] = useState(false);
  const [activeLink, setActiveLink] = useState(0);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();
  const navigate = useNavigate()

  const showLargeNav = () => {
    const navbarSmall = document.getElementsByClassName("gen-navbar-small")[0];
    navbarSmall.setAttribute("class", "gen-navbar-small secondary-bg animation gen-navbar-small-move");
    const navbar = document.getElementsByClassName("gen-navbar")[0];
    navbar.setAttribute('class', "gen-navbar secondary-bg gen-navbar-trans");
    setIsNavShowing(!isNavShowing);
  };

  const hideLargeNav = () => {
    const navbarSmall = document.getElementsByClassName("gen-navbar-small")[0];
    navbarSmall.setAttribute("class", "gen-navbar-small animation");
    const navbar = document.getElementsByClassName("gen-navbar")[0];
    navbar.setAttribute('class', "gen-navbar");
    setIsNavShowing(!isNavShowing);
  };

  const logoutbtn = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    window.location.href = '/login';
  }
  const dropdownContent = (
    <Button className='btn bg-brand' 
      loading={logoutLoading}
      onClick={logoutbtn}
      style={{marginLeft:'-30px'}}
      >
      Logout
    </Button>
  );

  const menulink = [
    { tile: 'Home', path: '/' },
    // { tile: 'Connect to Pro', path: '/findjob' },
    {
      tile: 'Connect to Pro',
      path:'/getquote',
      submenu: [
        { title: 'Get a Quote', path: '/getquote' },
      ]
    },
    { tile: 'Find a Project', path: '/findpro' },
    { tile: 'Privacy Policy', path: '/privacypolicy' },
    { tile: 'Contact Us', path: '/contactus' },
    { tile: 'About Us', path: '/aboutus' },
  ];

  useEffect(() => {
    const activeIndex = menulink.findIndex(menu => menu.path === location.pathname);
    setActiveLink(activeIndex !== -1 ? activeIndex : 0);

    setIsLoggedIn(localStorage.getItem("token") ? true : false);
  }, [location]);

  const toggleDropdown = () => setDropdownVisible(!dropdownVisible);

  
  const items = [
    {
      label: (
        <NavLink to={'/registeraspro'}>
          Creat account as Pro
        </NavLink>
      ),
      key: '0',
    },
    {
      label: (
        <NavLink to={'/registerasclient'}>
          Creat account as Client
        </NavLink>
      ),
      key: '1',
    },
  ];

  return (
    <>
      <div className='gen-navbar-container' style={{ position: 'relative' }}>
        <div className='w-100'>
          <div className="gen-navbar-small">
            <div className="gen-navbar-inner">
              <div className='gen-navbar-left'><img src={'/assets/images/logo.png'} width={'100%'} alt="logo" /></div>
              <div className="gen-navbar-right">
                <div className="sp-cover" onClick={showLargeNav}>
                  <span className="sp sp-1 sp-1-click"></span>
                  <span className="sp sp-2 sp-2-click"></span>
                  <span className="sp sp-3 sp-3-click"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='gen-navbar menu-glass'>
          <div className="gen-navbar-inner container">
            <div className='gen-navbar-left'>
              <img src='/assets/images/logo.png' width={'100%'} className='one' alt="logo" />
              <img src='/assets/icons/close.png' className='two' onClick={hideLargeNav} alt="close" style={{filter:'invert(1)'}} />
            </div>
            <ul className="gen-navbar-middle bg-blurr">
              {
                menulink.map((menu, index) =>
                  menu.submenu ? (
                    <li
                      key={index}
                      className="items py-2 dropdownC"
                      onMouseEnter={toggleDropdown}
                      onMouseLeave={toggleDropdown}
                    >
                      <NavLink
                        to={menu.path}
                        className={activeLink === index && isFooterLinkClicked ? "nav-item active" : "nav-item"}
                        onClick={() => { setActiveLink(index); hideLargeNav(); }}
                      >
                        <div className='align-center'>
                          <Text strong className='my-0 item-name'>Connect to Pro</Text>
                        </div>
                      </NavLink>
                      <ul className="dropdownMenu">
                          {menu.submenu.map((submenu, subIndex) => (
                            <li key={subIndex} className="dropdown-item">
                              <NavLink
                                to={submenu.path}
                                className="nav-item"
                                onClick={hideLargeNav}
                              >
                                {submenu.title}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                    </li>
                  ) : (
                    <li key={index} className='items py-2'>
                      <NavLink
                        to={menu.path}
                        className={activeLink === index && isFooterLinkClicked ? "nav-item active" : "nav-item"}
                        onClick={() => { setActiveLink(index); hideLargeNav(); }}
                      >
                        <div className='align-center'>
                          <Text strong className='my-0 item-name'>{menu.tile}</Text>
                        </div>
                      </NavLink>
                    </li>
                  )
                )
              }
            </ul>
            <div className='end-div displaynone'>
              <Flex gap={15} align='center' justify='end'>
                {isLoggedIn ? (
                  <Dropdown
                      overlay={dropdownContent}
                      trigger={['click']}
                      className='margin-top p-0'
                  >
                    <div shape='circle' size='large' className='btnafterlogin'>
                        <Image src='/assets/icons/user.png' preview={false} width={27} />
                    </div>
                  </Dropdown>
                ) : (
                <Button className='btn' onClick={()=>navigate('/login')}>
                  Login
                </Button>
                )}
                
                <Dropdown
                  menu={{
                    items,
                  }}
                >
                  <Button className='btn'>
                    Register
                  </Button>
                </Dropdown>
              </Flex>
            </div>


          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
